import { tailwindVariants } from '@air/utils-tailwind';

/**
 * Strato agentic-blue fills for Start task CTAs. Shared by the header split and the selection-bar
 * standalone button — primitive `color="blue"` is overridden because the design-system palette
 * does not match Strato's agentic blue.
 */
export const agenticStartTaskButton = tailwindVariants({
  base: 'shrink-0 gap-1.5 overflow-hidden rounded-8 ads:bg-agentic bg-[var(--color-agentic-blue)] ads:text-inverse text-white ads:hover:bg-hover-agentic hover:bg-[var(--color-agentic-blue-hover)] active:bg-[var(--color-agentic-blue-hover)] ads:active:bg-hover-agentic',
});

export const agenticStartTaskSegment = tailwindVariants({
  base: 'ads:bg-agentic bg-[var(--color-agentic-blue)] ads:text-inverse text-white ads:hover:bg-hover-agentic hover:bg-[var(--color-agentic-blue-hover)] active:bg-[var(--color-agentic-blue-hover)] ads:active:bg-hover-agentic',
  variants: {
    isPressed: {
      // The open half reads as pressed navy, not a second color (Strato changelog 2026-09-09).
      // Visual only for "Start task": `showChat` never un-presses, so it is not announced as a toggle.
      true: 'ads:bg-hover-agentic bg-[var(--color-agentic-blue-hover)]',
    },
  },
});
